import styles from '../css/Carrito.module.scss';
import { ButtonDark } from './ButtonDark';
import { ItemCarrito } from './ItemCarrito';
import { useEffect, useState } from 'react';
import { TotalCarrito } from './TotalCarrito';
import { useContextoGlobal } from '../ContextoGlobal';
import { Loader } from './Loader';

export const Carrito = ({ show, setShow }) => {
    const { itemsCarrito, mostrarLoader } = useContextoGlobal();
    const [total, setTotal] = useState(0);

    function pagar() {
        //onChange({ id, text });
    };

    useEffect(() => {
        if (show)
            document.body.style.overflow = 'hidden';
        else
            document.body.style.overflow = 'auto';
    }, [show])

    useEffect(() => {
        const nuevoTotal = itemsCarrito.reduce((acc, producto) => {
            return acc + producto.precio * producto.cantidad;
        }, 0);

        setTotal(nuevoTotal);
    }, [itemsCarrito])

    return (
        <>
            <div className={'modal-backdrop fade show ' + (show ? '' : 'd-none')} onClick={() => setShow(false)} />
            <div class={`${styles.carrito} ` + (show ? styles.mostrar : '')}>
                <div className='container-fluid px-3'>
                    <div className='row py-2 mb-2 '>
                        <div className="fw-bold col " >
                            <div className={'d-inline-block ' + styles.titulo}>Carrito</div>
                        </div>
                        <div className='col-2 w-auto'>
                            <button type="button" className="btn-close shadow-none" aria-label="Close" onClick={() => setShow(false)}></button>
                        </div>

                    </div>
                </div>
                <div className={styles.contItems}>
                    {mostrarLoader ? (
                        <Loader />
                    ) : itemsCarrito.length > 0 ? (
                        itemsCarrito.map(function (elem, i) {
                            return (
                                <ItemCarrito imagen={elem.imagen} nombre={elem.nombre} url={elem.url} idObjeto={'prod' + i}
                                    precio={elem.precio} precioOferta={elem.precio} on_sale={elem.on_sale} cantidad={elem.cantidad}
                                    id={elem.id} precioRegular={elem.precioRegular}
                                />
                            )
                        })
                    ) : (
                        <p className="text-center fw-bold mt-5">Aún no posee productos</p>
                    )
                    }
                </div>
                <div className='container-fluid p-3 '>
                    <TotalCarrito texto={'Subtotal'} valor={total} className={'mt-3'} />
                    <TotalCarrito texto={'Total'} valor={total} className={'fw-bold'} />
                    <div className='text-center'>
                        <ButtonDark text={'Pagar'} className={'w-75 mx-auto'} funcion={pagar} />
                    </div>
                    <div className='text-center'>Envío a coordinar</div>
                </div>
            </div>
        </>
    );
}